function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Calendar Empty Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13,0.5 C13.2761424,0.5 13.5,0.723857625 13.5,1 L13.4991,1.5 L14.7871,1.5 C16.2852424,1.5 17.5001,2.71485763 17.5001,4.213 L17.5001,14.787 C17.5001,16.2851424 16.2852424,17.5 14.7871,17.5 L3.2131,17.5 C1.71495763,17.5 0.5001,16.2851424 0.5001,14.787 L0.5001,4.213 C0.5001,2.71485763 1.71495763,1.5 3.2131,1.5 L4.4991,1.5 L4.5,1 C4.5,0.723857625 4.72385763,0.5 5,0.5 C5.27614237,0.5 5.5,0.723857625 5.5,1 L5.4991,1.5 L12.4991,1.5 L12.5,1 C12.5,0.723857625 12.7238576,0.5 13,0.5 Z M16.5001,6.5 L1.5001,6.5 L1.5001,14.787 C1.5001,15.7328576 2.26724237,16.5 3.2131,16.5 L14.7871,16.5 C15.7329576,16.5 16.5001,15.7328576 16.5001,14.787 L16.5001,6.5 Z M4.4991,2.5 L3.2131,2.5 C2.26724237,2.5 1.5001,3.26714237 1.5001,4.213 L1.5001,5.5 L16.5001,5.5 L16.5001,4.213 C16.5001,3.26714237 15.7329576,2.5 14.7871,2.5 L13.4991,2.5 L13.5,3 C13.5,3.27614237 13.2761424,3.5 13,3.5 C12.7238576,3.5 12.5,3.27614237 12.5,3 L12.4991,2.5 L5.4991,2.5 L5.5,3 C5.5,3.27614237 5.27614237,3.5 5,3.5 C4.72385763,3.5 4.5,3.27614237 4.5,3 L4.4991,2.5 Z",
  id: "calendar-empty-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "calendar-empty-Icon/Global/calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar-empty-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "calendar-empty-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#calendar-empty-path-1"
})));

var SvgCalendarEmpty = function SvgCalendarEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-empty.487ccc51.svg";
export { ForwardRef as ReactComponent };